import { nanoid } from 'nanoid'

export const tagsList = [
  {
    id: nanoid(),
    tagName: "javascript",
    tagDesc:
      "For questions regarding programming in ECMAScript (JavaScript/JS) and its various dialects/implementations (excluding ActionScript). Please include all relevant tags on your question;",
  },
  {
    id: nanoid(),
    tagName: "python",
    tagDesc:
      "Python is a multi-paradigm, dynamically typed, multipurpose programming language. It is designed to be quick to learn, understand, and use, and enforces a clean and uniform syntax.",
  },
  {
    id: nanoid(),
    tagName: "c#",
    tagDesc:
      "C# (pronounced 'see sharp') is a high level, statically typed, multi-paradigm programming language developed by Microsoft",
  },
  {
    id: nanoid(),
    tagName: "java",
    tagDesc:
      "Java is a high-level object oriented programming language. Use this tag when you're having problems using or understanding the language itself. ",
  },
  {
    id: nanoid(),
    tagName: "php",
    tagDesc:
      "PHP is a widely used, open source, general-purpose, multi-paradigm, dynamically typed and interpreted scripting language originally designed for server-side web development",
  },
  {
    id: nanoid(),
    tagName: "html",
    tagDesc:
      "HTML (HyperText Markup Language) is the markup language for creating web pages and other information to be displayed in a web browser.",
  },
  {
    id: nanoid(),
    tagName: "android",
    tagDesc:
      "Android is Google's mobile operating system, used for programming or developing digital devices (Smartphones, Tablets, Automobiles, TVs, Wear, Glass, IoT).",
  },
  {
    id: nanoid(),
    tagName: "css",
    tagDesc:
      "CSS is a representation style sheet language used for describing the look and formatting of HTML, XML documents and SVG elements including colors, layout, fonts, and animations",
  },
  {
    id: nanoid(),
    tagName: "Reactjs",
    tagDesc:
      "React is a JavaScript library for building user interfaces. It uses a declarative, component-based paradigm and aims to be both efficient and flexible.",
  },
  {
    id: nanoid(),
    tagName: "node.js",
    tagDesc:
      "Node.js is an event-based, non-blocking, asynchronous I/O runtime that uses Google's V8 JavaScript engine and libuv library. ",
  },
];
